import ComingSoon from '@/micros/coming-soon/coming-soon';
import { useAiEmail } from '@/utils/use-ai-email';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';

export default function Campaigns() {
  const enabled = useAiEmail();

  if (!enabled) {
    return <ComingSoon label="Campaigns" />;
  }

  return (
    <Container>
      <Text>TODO</Text>
    </Container>
  );
}
